import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useSelector } from 'react-redux';
import useDialog from './usePasswordDialog';
import { Trans } from "@lingui/react/macro";

const PasswordDialog = () => {
  const { open, onConfirm } = useSelector((state: {'passwordDialog': any}) => state.passwordDialog);
  const { closeDialog } = useDialog();

  return (
    <div>
      <Dialog open={open} onClose={() => closeDialog()}>
        <DialogTitle><Trans>Confirm Password</Trans></DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Trans>Please confirm delete of the entity.</Trans>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => closeDialog()}><Trans>Cancel</Trans></Button>
          {/* The same as the delete dialog: confirming closes it, or it stays
              open as a modal over the page. */}
          <Button
            onClick={() => {
              closeDialog();
              onConfirm('password');
            }}
          ><Trans>OK</Trans></Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default PasswordDialog;
